/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceSendEmailRequest
 */
export interface InvoiceSendEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof InvoiceSendEmailRequest
     */
    email?: string | null;
}

/**
 * Check if a given object implements the InvoiceSendEmailRequest interface.
 */
export function instanceOfInvoiceSendEmailRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InvoiceSendEmailRequestFromJSON(json: any): InvoiceSendEmailRequest {
    return InvoiceSendEmailRequestFromJSONTyped(json, false);
}

export function InvoiceSendEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceSendEmailRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function InvoiceSendEmailRequestToJSON(value?: InvoiceSendEmailRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}

